<mat-list  class="object-content-list-source-array-sort common-search-menu {{viewName}}">
  @for (s of contentListSource.sortFields; track $index) {
    <button
      mat-menu-item
      [ngClass]="{'active':contentListSource.order === s}"
    >
      <mat-radio-button
        [checked]="contentListSource.order === s"
        [value]="s"
        (click)="changeSortOrder(s)"
        (keydown)="null"
      >
        <span class="common-search-menu__radio-text">
          {{ s.description | translate }}
        </span>
      </mat-radio-button>
    </button>
  }
</mat-list>
